import { matchPairs } from '@/mocks/home';

export default function MatchCompare() {
  return (
    <section id="match" className="w-full bg-background-100 border-y border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <div className="text-[11px] tracking-[0.3em] text-secondary-700 mb-3">同款对照</div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              把相似的摆在一起看
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
            左为截图裁切，右为同款候选。差异点写在下方，像不像由你判断。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {matchPairs.map((pair) => (
            <article key={pair.id} className="bg-background-50 rounded-lg border border-background-200/70 p-4 md:p-6">
              <div className="flex items-center gap-3 mb-5">
                <span className="px-2.5 py-1 rounded-md bg-primary-100 text-primary-800 text-[11px] tracking-wider">
                  {pair.label}
                </span>
              </div>

              <div className="grid grid-cols-2 gap-3 md:gap-4">
                <div>
                  <div className="w-full aspect-square rounded-md overflow-hidden bg-background-200">
                    <img
                      src={pair.shot}
                      alt="私拍吃瓜同款 截图裁切"
                      title="私拍吃瓜同款 截图细节"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="mt-2.5 text-[11px] tracking-wider text-foreground-500 text-center">截图裁切</div>
                </div>
                <div>
                  <div className="w-full aspect-square rounded-md overflow-hidden bg-background-200">
                    <img
                      src={pair.cand}
                      alt="私拍吃瓜同款 同款候选"
                      title="私拍吃瓜同款 候选细节"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="mt-2.5 text-[11px] tracking-wider text-foreground-500 text-center">同款候选</div>
                </div>
              </div>

              <p className="mt-5 text-sm leading-relaxed text-foreground-600">{pair.note}</p>
              <a
                href="#entry"
                className="mt-4 inline-flex items-center gap-1.5 text-sm text-primary-600 whitespace-nowrap hover:text-primary-700 cursor-pointer"
              >
                看完整比对
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}